import { ReactComponent as SaveFilterPreferenceSvg } from 'assets/svg/SaveFilterPreference.svg';
import AppliedFilters from 'components/client-pool/AppliedFilters';
import { omit } from 'lodash';
import usePropertyRequestsStore from 'store/propertyRequestsStore';
import { clearFilter, formatFilterStrings } from 'util/formatFilterStrings';
import { urgencyOptions } from 'util/urgencySelector';

interface Props {
    setSavedSearchFilterVisible: React.Dispatch<React.SetStateAction<boolean>>;
}
export default function SelectedFilters({ setSavedSearchFilterVisible }: Props) {
    const { propertyRequestQueryFilter, setLocalFilters, setPropertyRequestQueryFilter, localFilters, selectedFilter } = usePropertyRequestsStore();
    const hasAnyTruthyValue = Object.values(omit(propertyRequestQueryFilter, ['propertyCountry', 'propertyState', 'propertyCity'])).some(Boolean);

    const isDisabled = Object.values(propertyRequestQueryFilter).every((value) => !value) || Boolean(selectedFilter);
    return (
        <div className={`mt-2 mb-4 flex lg:flex-row flex-col lg:items-center  ${hasAnyTruthyValue ? 'justify-between' : 'justify-end'}`}>
            {hasAnyTruthyValue && (
                <div className="flex items-center">
                    <AppliedFilters
                        isClearButtonVisible
                        options={formatFilterStrings({
                            ...propertyRequestQueryFilter,
                            urgency: urgencyOptions.find((option) => option.value === Number(propertyRequestQueryFilter.urgency))?.label,
                        })}
                        onClearFilter={(filterType) =>
                            clearFilter(propertyRequestQueryFilter, filterType, setPropertyRequestQueryFilter, localFilters, setLocalFilters)
                        }
                        action="clear"
                    />
                </div>
            )}
            <button
                className={`flex  items-center mr-6 gap-2 text-my-blue lg:mt-0 mt-4 p-2 ${isDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                onClick={() => setSavedSearchFilterVisible(true)}
                disabled={isDisabled}
            >
                <SaveFilterPreferenceSvg className="h-6 w-6 ml-2" />
                <h3>Saved Search Filter</h3>
            </button>
        </div>
    );
}
